<template>
  <div>
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="tolast()">
          <span class="icon icon-left"></span>返回
        </a>
      </nav>

    <div class="content" style="margin-bottom: 3rem">
      <div class="content-block-title">{{plan.customerPlanName}}成员信息</div>
      <div class="list-block">
        <ul v-for="member in memberDetails ">
          <li class="item-content item-link">
            <router-link :to="{path:'/MemberDetails',query: {member: member, plan: plan}}">
              <div class="item-inner">
                <i class="icon icon-me" style="margin-right: 20px"></i>
                <div class="item-title" v-if="member.role === 1">储值联系人</div>
                <div class="item-title" v-else-if="member.role === 2">积分联系人</div>
                <div class="item-title" v-else-if="member.role === 3">管理联系人</div>
                <div class="item-title" v-else-if="member.role === 4">对账联系人</div>

                <div class="item-title" v-else-if="member.role === 5">普通成员</div>
                <div class="item-title" v-else>未知</div>

                <div class="item-after" style="margin-left: 15px;font-size: smaller">
                  {{member.customerPlanMemberName}}-{{member.customerPlanMemberNo}}
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
//  import $ from 'jquery'
  import {mapState} from 'vuex'
  export default {
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    data () {
      return {
        plan: {},
        memberDetails: {}
      }
    },
    methods: {
      fetchData () {
        this.plan = this.$route.query.plan
        this.gcapi('retrieveCustomerPlanMemberInformation', this.plan.GUID).then((response) => {
          this.memberDetails = response.body.result
          console.log(this.memberDetails)
        })
      },
      tolast () {
        this.$router.push({name: 'VipPlanDetails'})
      },
      gotovipdetails () {
        console.log(1)
      }
    }
  }
</script>


<style scoped>
  .item-inner {
    padding-bottom: 0rem
  }
</style>



// WEBPACK FOOTER //
// VipPlanMemberDetails.vue?7c9bca22